import styled from 'styled-components';

/**
 * Figma SDW/S3a "Bind document to fields": a 3rem bordered row carrying an icon tile, the status
 * line, and the editor action at the far end. Replaces what used to be a bare "Open editor"
 * button, so the panel says what is left to do before the author opens anything.
 */
export const BindingCard = styled.div`
	display: flex;
	align-items: center;
	align-self: stretch;
	gap: 0.25rem;
	padding: 0.25rem 0.5rem;
	border: 1px solid ${({ theme }) => theme.v3.colors.gray[3]};
	border-radius: 0.25rem;
`;

export const IconTile = styled.div`
	display: flex;
	align-items: center;
	padding: 0.5rem;
	border-radius: 0.25rem;
	background-color: ${({ theme }) => theme.v3.colors.gray[0]};
`;

/** Takes the slack so the button sits at the far end; `min-width: 0` lets the status line clip. */
export const CardText = styled.div`
	display: flex;
	flex: 1;
	min-width: 0;
	flex-direction: column;
	padding: 0 0.5rem;
`;

/**
 * The status line stays on one line so the card keeps Figma's 3rem height. Mantine's `truncate`
 * alone does not hold here: the app sets `white-space: pre-line` on every Text, which outranks
 * the `nowrap` that prop relies on.
 */
export const StatusLine = styled.span`
	color: ${({ theme }) => theme.v3.colors.dark[0]};
	font-size: 0.75rem;
	line-height: 1rem;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
`;
